const pushToDataLayer = payload => {
  if (typeof window === 'undefined' || !payload) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

export default pushToDataLayer;
